<template>
  <div class="chart-line">
    <div class="line-header">
      <div class="line-title">
        <BaseIcon
          :name="item.header.titleIcon"
          v-if="item.header.titleIcon"
          width="1em"
          height="1em"
        />
        {{ item.header.title }}
        <BaseIcon
          :name="item.header.subIconTitle"
          v-if="item.header.subIconTitle"
          class="icon-margin-suffix"
          width="1rem"
          height="1rem"
        />
      </div>
      <div class="line-content-error" v-if="item.header.isError && childQuery">
        <span class="line-errors">
          {{ getChilds('total', childSource) }} {{ $t('bm.errors') }}
        </span>
        <span>
          {{ getChilds('pm', childSource) }} {{ $t('apm.errors-per-min') }}
        </span>
      </div>

      <div class="line-icon" v-if="item.header.toolbar || item.header.isError">
        <router-link
          v-if="item.header.displayCustomButton"
          :to="{
            name: item.header.customButtonProp.route,
            query: {
              type: item.header.customButtonProp.key,
              entity: item.entityType,
            },
          }"
        >
          <div class="custom-button">
            {{ item.header.customButtonProp.title }}
          </div>
        </router-link>
        <span
          class="icon-class"
          @click="handleZoomOut"
          :id="`${replaceSpaceInId(item.header.title)}-zoom-out`"
        >
          <BaseIcon name="zoomOut" width="2.438em" height="2.438em" />
        </span>
        <span
          class="icon-class"
          @click="handleZoomIn"
          :id="`${replaceSpaceInId(item.header.title)}-zoom-in`"
        >
          <BaseIcon name="zoomIn" width="2.438em" height="2.438em" />
        </span>
        <span
          class="icon-class"
          @click="handleReset"
          :id="`${replaceSpaceInId(item.header.title)}-zoom-reset`"
        >
          <BaseIcon name="reset" width="1.438em" height="1.438em" />
        </span>
      </div>
    </div>
    <div class="chart-body">
      <apexchart
        height="100%"
        type="area"
        :options="options"
        :series="option"
        ref="chart"
      ></apexchart>
    </div>
  </div>
</template>
<script>
import BaseIcon from '@/rex-components/BaseIcon.vue';
import shortenLargeNumber from '@/utils/numberShortner';
import {
  ToolTip,
  Grid,
  Legend,
  Markers,
  ChartToolBar,
  Animations,
  XAxisConfig,
  YAxisConfig,
} from '@/components/charts/charts.global.config';
import { replaceSpaceInId } from '../../utils/helper-function';
export default {
  components: { BaseIcon },
  name: 'ApexChartArea',
  props: {
    data: {},
    type: {},
    intervalTime: {},
    item: {},
    index: {},
    childSource: {},
    childQuery: {},
  },
  data: function () {
    return {
      minX: 1,
      maxX: this.intervalTime.length,
      options: {
        chart: {
          id: `vuechart-area-${this.index}`,
          width: '100%',
          height: '100%',
          group:
            typeof this.item.isSynchronized === 'undefined' ||
            this.item.isSynchronized
              ? 'group'
              : '',
          background: 'inherit',
          events: {
            zoomed: (chartContext, { xaxis, yaxis }) => {
              this.updateMinMax(xaxis);
            },
            // beforeMount: (chartContext, config) => {
            //   console.log('config', config);
            //   this.setConfig(config);
            // }
          },
          toolbar: ChartToolBar,
        },
        grid: Grid,
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.9,
            opacityTo: 0.2,
            stops: [0, 100],
          },
        },
        stroke: {
          curve: 'smooth',
          width: 1,
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: 'hollow',
        },
        tooltip: {
          enabled: true,
          enabledOnSeries: undefined,
          shared: true,
          followCursor: false,
          intersect: false,
          inverseOrder: false,
          custom: undefined,
          fillSeriesColor: false,
          theme: 'dark',
          style: {
            fontSize: '12px',
            fontFamily: undefined,
          },
          onDatasetHover: {
            highlightDataSeries: false,
          },
          x: {
            show: true,
            format: 'dd MMM',
            formatter: undefined,
          },
          y: {
            formatter: undefined,
            title: {
              formatter: (seriesName) => seriesName,
            },
          },
          z: {
            formatter: undefined,
            title: 'Size: ',
          },
          marker: {
            show: true,
          },
          items: {
            display: 'flex',
          },
          fixed: {
            enabled: false,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
          },
        },
        colors: this.item.chartColor,
        xaxis: {
          tickAmount: this.intervalTime.length > 14 ? 5 : 3,
          ...XAxisConfig,
          title: {
            text: this.item.axisLabels.x,
            ...XAxisConfig.title,
          },
          labels: {
            ...XAxisConfig.labels,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            maxHeight: 120,
            style: {
              colors: [],
              fontSize: '0.875em',
              ...XAxisConfig.labels.style,
            },
          },
        },
        yaxis:
          this.item.header.isError && this.childSource
            ? {
                ...YAxisConfig,
                min: 0,
                max: 100,
                tickAmount: 4,
                title: {
                  text: this.item.axisLabels.y,
                  align: 'left',
                  ...YAxisConfig.title,
                  offsetX: 0,
                  offsetY: 0,
                },
              }
            : {
                ...YAxisConfig,
                title: {
                  text: this.item.axisLabels.y,
                  align: 'left',
                  ...YAxisConfig.title,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
        legend: !this.item.showLegendForSingle
          ? Legend
          : { ...Legend, showForSingleSeries: true },
      },
    };
  },

  methods: {
    resize() {
      const chart = this.$refs.chart;
      chart.myChart.resize();
    },
    setConfig(config) {
      // console.log('configss', config.globals.maxX);
      // this.minX = config.globals.maxX;
      // this.maxX = config.globals.maxX;
    },
    handleZoomIn() {
      // Find minMax for x

      try {
        if (this.$refs.chart.chart.w.globals.minX)
          this.minX = this.$refs.chart.chart.w.globals.minX;
        if (this.$refs.chart.chart.w.globals.maxX)
          this.maxX = this.$refs.chart.chart.w.globals.maxX;
      } catch (error) {
        // Todo: Handle error
      }

      if (
        typeof this.minX === 'undefined' &&
        typeof this.maxX === 'undefined'
      ) {
        this.handleReset();
      }
      if (this.maxX - this.minX > 2) {
        const centerX = (this.minX + this.maxX) / 2;
        let newMinX = (this.minX + centerX) / 2;
        let newMaxX = (this.maxX + centerX) / 2;
        const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
        this.minX = newMinXMaxX.minX;
        this.maxX = newMinXMaxX.maxX;
        this.$refs.chart.zoomX(this.minX, this.maxX);
      }
    },
    handleReset() {
      this.$refs.chart.zoomX();
      this.minX = 1;
      this.maxX = this.intervalTime.length;
    },
    _getNewMinXMaxX(newMinX, newMaxX) {
      return {
        minX: Math.floor(newMinX),
        maxX: Math.floor(newMaxX),
      };
    },
    updateMinMax(xaxis) {
      this.minX = xaxis.min;
      this.maxX = xaxis.max;
    },
    handleZoomOut() {
      // this.$refs.chart.zoomX();
      //Find minMax for x

      try {
        if (this.$refs.chart.chart.w.globals.minX)
          this.minX = this.$refs.chart.chart.w.globals.minX;
        if (this.$refs.chart.chart.w.globals.maxX)
          this.maxX = this.$refs.chart.chart.w.globals.maxX;
      } catch (error) {
        // Todo: Handle error
      }

      if (
        typeof this.minX === 'undefined' &&
        typeof this.maxX === 'undefined'
      ) {
        this.handleReset();
      }
      if (this.minX > 0 && this.maxX - this.minX >= 1) {
        const centerX = (this.minX + this.maxX) / 2;
        let newMinX = this.minX - (centerX - this.minX);
        let newMaxX = this.maxX - (centerX - this.maxX);
        const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
        this.minX = newMinXMaxX.minX;
        this.maxX = newMinXMaxX.maxX;
        this.$refs.chart.zoomX(this.minX, this.maxX);
      }
    },
    replaceSpaceInId,
    getChilds(type, val) {
      if (type === 'pm') {
        const item = val.find((o) => o.metricType === 'pm');
        if (item) {
          return shortenLargeNumber(item.avgNum, 1);
        } else return 0;
      } else if (type === 'total') {
        const item = val.find((o) => o.metricType === 'total');
        if (item) {
          return shortenLargeNumber(item.avgNum, 1);
        } else return 0;
      } else return 0;
    },
    getLargeNumberByUnits(val) {
      return shortenLargeNumber(val, 1);
    },
  },
  computed: {
    option() {
      const keys = Object.keys(this.data || {}).filter(
        (i) => Array.isArray(this.data[i]) && this.data[i].length,
      );
      // eslint-disable-next-line no-unused-vars
      const temp = keys.map((i, index) => {
        const serie = {
          name: i,
          data: this.data[i].map((item, itemIndex) => ({
            x:
              typeof this.intervalTime[itemIndex] === 'undefined'
                ? ''
                : this.intervalTime[itemIndex],

            y: !(this.item.header.isError && this.childSource)
              ? item
              : item / 100,
          })),
        };
        return serie;
      });
      return temp;
    },
  },
  watch: {
    minX(oldVal, newVal) {
      // console.log('oldval', oldVal);
      // console.log('newval', newVal);
    },
  },
};
</script>
<style lang="scss" scoped>
.chart-body {
  margin-right: 0.125em;
  margin-left: 0.12rem;
  height: 20.625em;
  border-radius: 1.0625em;
}
.chart-line {
  width: 100%;

  border-radius: 1.0625em;
  background-color: inherit;
}
.line-header {
  height: 2.375em;
  border-bottom: 0.0063em solid $border-primary;
  @include flex-center-justify(space-between);
  color: $font-primary;

  .line-title {
    margin-left: 1em;
    font-family: $semi-bold;
  }
  .line-icon {
    margin-right: 0.8125em;

    @include flex-center-justify(space-between);
  }
  .icon-class:hover {
    cursor: pointer;
    svg {
      fill: $font-secondary !important;
    }
  }
  .icon-class:last-child {
    margin-left: 0.3125em;
  }
  .icon-class:first-child {
    margin-right: -0.3125em;
  }
}
foreignObject > div.apexcharts-legend {
  max-height: 35px !important;
  overflow-y: auto !important;
}
.custom-button {
  background: $color-brand-accent;
  width: 6.94em;
  height: 1.875em;
  color: $font-contrast;
  border-radius: 0.4375em;
  cursor: pointer;
  font-size: 0.75em;
  text-align: center;
  align-items: center;
  padding-top: 2px;
  &:hover {
    text-decoration: underline;
  }
}

.line-content-error {
  color: $poor;
  margin-left: 1em;
  .line-error-percentage {
    margin-right: 1.125rem;
  }
  .line-errors {
    margin-right: 1em;
  }
}
.icon-margin-suffix {
  margin-right: 0.5em;
  @include svg-fill($color-active-blue);
  vertical-align: super;
}
</style>
